export default "__VITE_ASSET__CWDJjoET__"